<!--
Author: TangChen
Date: 2018-09-10
Desc: 校验密码手机号或银行卡页面鉴权组件
 -->
<template>
    <div class="comp-reset-num comp">
        <div class="reset-num-box">
            <nav-bar :navs="navs" />
            <div class="check-acct">
                <div v-if="phoneChecked" class="info-box">
                    <el-alert
                        class="info-alert"
                        title="您的手机号码已绑定交易账户，请您进行身份验证"
                        type="info"
                        show-icon
                        :closable="true"
                    />
                </div>
                <el-form
                    v-if="phoneChecked"
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item v-if="phoneChecked" label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.name }}
                        </div>
                    </el-form-item>
                    <el-form-item v-if="phoneChecked" label="证件号码：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.certNo }}
                        </div>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="userName">
                        <el-input v-model.trim="pwdForm.userName" placeholder="请输入真实姓名" :maxlength="20" />
                    </el-form-item>
                    <el-form-item label="证件类型：" prop="certType">
                        <el-select v-model="pwdForm.certType" placeholder="请选择证件类型">
                            <el-option
                                v-for="item in certTypes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="证件号码：" prop="certNo">
                        <el-input v-model.trim="pwdForm.certNo" placeholder="请输入证件号码" :maxlength="20" />
                    </el-form-item>
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" v-on:click="submitInfo('pwdForm')">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="returnCheck">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="phoneChecked" label="" class="form-text">
                        <div class="step-info">
                            以上身份信息与本人不符，放弃该交易账户，
                            <span class="info-btn" v-on:click.prevent="showPwd(true)">进入下一步</span>
                        </div>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="!checked"
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item v-if="checkBank" label="姓名：" prop="userName">
                        <el-input v-model.trim="pwdForm.userName" placeholder="请输入真实姓名" :maxlength="20" />
                    </el-form-item>
                    <el-form-item v-if="checkBank" label="证件类型：" prop="certType">
                        <el-select v-model="pwdForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                            <el-option
                                v-for="item in certTypes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="checkBank" label="证件号码：" prop="certNo">
                        <el-input v-model.trim="pwdForm.certNo" placeholder="请输入证件号码" :maxlength="20" />
                    </el-form-item>
                    <el-form-item v-if="checkBank" label="所属银行：" prop="bankType" class="bank">
                        <div class="bank-msg" :style="{'opacity':bankInfo.channelid?1:0}" v-on:click.prevent="showBank">
                            <div
                                v-if="bankInfo.channelid"
                                class="bank-img-sel clear"
                                :class="{'bg-w':bankInfo.channelid}"
                            >
                                <img :src="$util.getImg(bankInfo.bankid)">
                                <span class="k-text-flow" :title="bankInfo.channelname">{{ bankInfo.channelname.toString().substr(0,6) }}</span>
                                <i class="paycenter" :title="bankInfo.paycentername">{{ bankInfo.paycentername.toString().substr(0,4) }}</i>
                            </div>
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankType"
                            placeholder="请选择所属银行"
                            :maxlength="20"
                            suffix-icon="fa fa-money-check"
                        />
                    </el-form-item>
                    <el-form-item v-if="checkBank" label="银行卡号码：" prop="bankNo">
                        <div class="bank-code el-message--warning" :class="{'show':showBankCard&&pwdForm.bankNo!==''}">
                            {{ $util.getNewCard(pwdForm.bankNo) }}
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankNo"
                            placeholder="请输入银行卡号码"
                            :maxlength="20"
                            v-on:focus="showBankCard=true"
                            v-on:blur="showBankCard=false"
                        />
                    </el-form-item>
                    <el-form-item v-if="!phoneChecked" label="手机号码：" prop="mobile">
                        <el-input v-model.trim="pwdForm.mobile" :placeholder="plaC" :maxlength="11" />
                    </el-form-item>
                    <!--<el-form-item v-if="(!phoneChecked && !checkBank) || (bankInfo && bankInfo.identifytype==='1')" label="手机验证码：" prop="verifyCode">
                        <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input>
                    </el-form-item>-->
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" :disabled="time>0" v-on:click="mobileCheck">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="returnLogin">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <bank-lists v-if="checkBank" :bank-visible="bankVisible" v-on:bank-hide="getBankMsg" />
            <set-pwd v-if="pwdShow" :pwd-con="pwdSet" :proto="true" v-on:pwd-get="pwdOk" />
            <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
            <mobile-code :mobile-visible="locked" v-on:verify-in="mobileCode" />
            <result v-if="pwdResult" :result="result" v-on:login-now="findPwd" v-on:return-login="backLogin" />
        </div>
    </div>
</template>
<script>
import bankLists from "@/components/form/bankLists.vue";
import navBar from "@/components/layout/navBar.vue";
import setPwd from "@/components/layout/setPwd.vue";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCode.vue";
import result from "@/components/layout/result.vue";
export default {
    name: "ResetNum",
    components: {
        navBar,
        bankLists,
        setPwd,
        mobileCode,
        imgCode,
        result
    },
    props: {
        way: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            time: 0, // 验证码再次发送间隔
            pwdForm: { // 表单参数配置
                userName: "",
                certType: "0",
                certNo: "",
                bankType: "",
                bankNo: "",
                mobile: "",
                verifyCode: ""
            },
            acctInfo: { // 用户信息表单参数配置
                name: "",
                certNo: ""
            },
            showBankCard: false,
            // 密码参数设置
            pwdSet: {
                text: "登录"
            },
            result: {// 结果页面信息
                cla: "register-success",
                msg: "恭喜您，密码已设置成功！",
                btnMsg: "该密码用于登录及交易验证，请牢记并妥善保管",
                btnL: {
                    text: "立即登录",
                    event: "return-login"
                },
                btnR: {
                    ctd: "秒后自动跳转登录",
                    time: 10,
                    event: "return-login"
                }
            },
            phoneChecked: false, // 是否手机校验通过
            infoChecked: "0", // 是否校验用户身份信息
            pwdShow: false, // 是否显示密码重置页面
            pwdResult: false, // 是否显示密码修改结果页
            bankVisible: false, // 是否弹出银行卡列表
            dialogVisible: false, // 是否显示图片验证码弹框
            mobileVisible: false, // 是否显示手机验证码弹框
            checked: false, // 手机或银行卡校验是否通过
            navs: [{ val: "验证身份信息", active: true }, { val: "设置新密码" }, { val: "完成修改", icon: "fa fa-check" }], // 导航栏配置
            certTypes: [], // 证件类型
            btnMsg: "获取短信验证码",
            plaC: "请输入绑定手机号码",
            checkBank: false, // 是否是银行卡校验
            locked: false, // 是否已发送短信验证码
            bankInfo: {},
            rules: { // 校验规则
                userName: [
                    { validator: this.$util.validateName, trigger: "blur" }
                ],
                certType: [
                    { required: true, message: "请选择证件类型", trigger: "change" }
                ],
                certNo: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                bankType: [
                    { required: true, message: "请选择所属银行", trigger: "blur" }
                ],
                bankNo: [
                    { required: true, message: "请输入银行卡号码", trigger: "blur" },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobile: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                verifyCode: [
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ]
            }
        };
    },
    created () {
        this.checkBank = this.way === "trade";
        this.certTypes = this.$cache.getDict("130007");
        if (this.checkBank) {
            this.plaC = "请输入银行预留手机号码";
            this.pwdSet = {
                text: "交易"
            };
        }
    },
    methods: {
        /* 回退到鉴权界面 */
        returnCheck () {
            this.phoneChecked = false;
            this.checked = false;
            this.locked = false;
            this.$refs["pwdForm"].resetFields();
        },
        // 再次校验证件号码
        checkCertNoAgain () {
            this.$refs.pwdForm.validateField("certNo");
        },
        /* 回到找回密码页面 */
        findPwd () {
            this.$router.push({ name: "resetpwdway", query: { tit: "找回密码" } });
        },
        /* 显示密码界面 */
        showPwd (flag) {
            this.checked = true;
            this.pwdShow = true;
            this.navs = [{ val: "验证身份信息", active: true }, { val: "设置新密码", active: true }, { val: "完成修改", icon: "fa fa-check" }];
            this.phoneChecked = false;
            if (flag) {
                this.infoChecked = "1";
            }
        },
        /* 提交表单数据,校验手机验证码 */
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.checkBank || this.bankInfo.identifytype === "1") {
                        if (!this.locked) {
                            this.$message({
                                type: "warning",
                                message: "请先发送手机短信验证码"
                            });
                            return false;
                        }
                        this.locked = true;
                    } else {
                        this.sendBank();
                    }
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const encNum = this.pwdForm.certNo;
                    this.$util.request("acct/resetloginpwd/validate", {
                        certificatetype: this.pwdForm.certType,
                        certificateno: encNum,
                        custname: this.pwdForm.userName
                    }, "POST").then(res => {
                        if (res.data) {
                            this.phoneChecked = false;
                            this.pwdShow = true;
                            this.navs = [{ val: "验证身份信息", active: true }, { val: "设置新密码", active: true }, {
                                val: "完成修改",
                                icon: "fa fa-check"
                            }];
                        }
                    });
                }
                return false;
            });
        },
        mobileCode(val){
            this.locked = false;
            if(val){
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 校验手机验证码 */
        checkVerifyCode (val) {
            let url = "acct/resetloginpwd/checksms";
            if (this.checkBank) {
                url = "acct/resettradepwd/authcheckmsg";
            }
            this.$util.request(url, {
                verifycode: val
            }, "POST").then(res => {
                if (res.data) {
                    this.checked = true;
                    if (res.data[0] && res.data[0].bindflag === "1") {
                        this.phoneChecked = true;
                        this.acctInfo.name = res.data[0].custname;
                        this.acctInfo.certNo = res.data[0].certificateno;
                        this.$refs["pwdForm"].resetFields();
                    } else {
                        this.pwdShow = true;
                        this.navs = [{ val: "验证身份信息", active: true }, { val: "设置新密码", active: true }, { val: "完成修改", icon: "fa fa-check" }];
                    }
                }
            });
        },
        /* 显示银行卡列表弹框 */
        showBank () {
            this.bankVisible = !this.bankVisible;
        },
        /* 回调银行卡信息 */
        getBankMsg (val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
            }
        },
        /* 获取图形验证码值 */
        getVerifyCode (val) {
            this.dialogVisible = false;
            if (val) {
                if(this.checkBank){
                    this.sendBank(val);
                    return;
                }
                this.$util.sendSms(this, val, "pwdForm", "acct/resetloginpwd/sendsms");
            }
        },
        /* 回到登录页面 */
        backLogin () {
            this.$router.push("/");
        },
        /* 提交表单数据，重置密码 */
        pwdOk (action, val) {
            if (action) {
                const encPwd = this.$util.enc(val.pwd);
                let url = "acct/resetloginpwd/reset";
                let data = {
                    unbindtrdacct: this.infoChecked,
                    newpwd: encPwd
                };
                if (this.checkBank) {
                    url = "acct/resettradepwd/reset";
                    data = {
                        newpwd: encPwd
                    };
                }
                this.$util.request(url, data, "POST").then(res => {
                    if (res.data) {
                        this.pwdShow = false;
                        this.pwdResult = true;
                        this.navs = [{ val: "验证身份信息", active: true }, { val: "设置新密码", active: true }, {
                            val: "完成修改",
                            icon: "fa fa-check",
                            active: true
                        }];
                    } else {
                        this.result = {// 结果页面信息
                            cla: "register-fail",
                            msg: "很抱歉，密码重置失败！",
                            btnMsg: "你的账户信息已超时，请你重新找回密码",
                            btnL: {
                                text: "找回密码",
                                event: "login-now"
                            },
                            btnR: {
                                text: "返回登录",
                                event: "return-login"
                            }
                        };
                    }
                });
            } else {
                this.checked = false;
                this.navs = [{ val: "验证身份信息", active: true }, { val: "设置新密码" }, { val: "完成修改", icon: "fa fa-check" }];
                this.locked = false;
                this.pwdShow = false;
            }
        },
        /* 校验证件号码 */
        checkCertNo (rule, value, callback) {
            this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
        },
        /* 提交表单数据 */
        mobileCheck () {
            const _this = this;
            let mes = "";
            // 处理银行卡找回密码表单数据校验
            if (
                _this.checkBank ||
            (!_this.hasTranAcct && _this.hasTranAcct !== undefined)
            ) {
                for (const key in _this.pwdForm) {
                    if (key !== "verifyCode" && key !== "type") {
                        _this.$refs["pwdForm"].validateField(key, function(str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            }
            if (mes !== "") {
                return false;
            }
            this.dialogVisible = true;
        },
        /* 银行卡鉴权发送鉴权信息 */
        sendBank (val) {
            let _this = this;
            let url = "acct/resettradepwd/authsend";
            let data = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName,
                mobile: this.pwdForm.mobile,
                bankcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                verifycode: val
            };
            this.$util.request(url, data, "POST").then(res => {
                if (res.data) {
                    /* 倒计时 */
                    if (this.bankInfo.identifytype === "1") {
                        this.$message({
                            type: "success",
                            message: "发送手机短信验证码成功"
                        });
                        let result = res.data[0];
                        if(result.comtype && result.comtype === "socket"){
                            this.showPwd();
                        }else {
                            _this.time = res.data[0].sendperiod;
                            _this.locked = true;
                            _this.$util.btnDisabled(this);
                            _this.submitForm("pwdForm");
                        }
                    } else if (this.bankInfo.identifytype === "2") {
                        this.showPwd();
                    } else if (this.bankInfo.identifytype === "3") {
                        const pageUrl = res.data[0].url;
                        this.$util.newWinOpen(pageUrl);
                        this.$util.confirmBankAuth(this, {}, "acct/resettradepwd/authresult", function () {
                            _this.showPwd();
                        });
                    }
                }
            });
        },
        /* 返回登录页 */
        returnLogin () {
            this.$router.back();
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-reset-num {
    .reset-num-box {
        padding: 20px 80px;
    }
}
</style>
